var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._class},[_vm._t("default"),(_vm.onClose)?_c('Icon',{class:_vm._classIcon,attrs:{"icon":"clear"},on:{"click":_vm.onRemoveTagItem}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }